export enum SurveyStatus {
  Draft = 'Draft',
  ReadyToSend = 'ReadyToSend',
  Active = 'Active',
  Closed = 'Closed',
}
export default SurveyStatus;
